import type { PosStockNoticeVariant, PosStockWarningDetail } from '../domain/posTypes';
import type { Product } from '../../catalog/domain-api';

export function mapStockWarningsByProductId(details: PosStockWarningDetail[]): Map<string, PosStockWarningDetail> {
  return new Map(details.map((d) => [d.productId, d] as const));
}

export const CART_LINE_STOCK_HINT = 'Sin stock' as const;

export function getStockWarningSeverity(detail: PosStockWarningDetail): 'warning' | 'critical' {
  if (detail.warningType === 'no_stock') return 'critical';
  if (detail.sellable <= 0) return 'critical';
  return 'warning';
}

/**
 * Resumen del bloqueo de checkout por stock. Nombra los productos para que el
 * cajero entienda qué falta reponer antes de poder cobrar.
 */
export function formatCheckoutStockIssuesSummary(details: PosStockWarningDetail[]): string {
  if (details.length === 0) return '';
  const head = details.length === 1 ? '1 línea sin stock' : `${details.length} líneas sin stock`;
  const names = details.map((d) => d.name?.trim()).filter((n): n is string => !!n);
  if (names.length === 0) return head;
  const shown = names.slice(0, 3).join(', ');
  const suffix = names.length > 3 ? ` y ${names.length - 3} más` : '';
  return `${head}: ${shown}${suffix}`;
}

export function buildStockTapNoticeCopy(product: Product, policy: PosStockNoticeVariant) {
  if (policy === 'block') {
    return {
      variant: 'block' as const,
      title: 'Sin stock',
      body: `No podés sumar "${product.name}". Reponé en Stock.`,
      canAdd: false,
    };
  }
  if (policy === 'warn') {
    return {
      variant: 'warn' as const,
      title: 'Sin stock',
      body: `"${product.name}" está en cero. Podés cobrarlo igual o reponer en Stock.`,
      canAdd: true,
    };
  }
  return {
    variant: 'allow' as const,
    title: 'Sin stock',
    body: `"${product.name}" está en cero. Podés sumarlo y corregir Stock después.`,
    canAdd: true,
  };
}

